import * as React from 'react';
import makeAnimated from 'react-select/animated';

import {
  ITeam,
  ISelectableEntity,
  ISelectOption,
} from '../../../../data/types';
import { useEntities } from '../../../../hooks/useEntities';

import { Select } from '../Select';

interface IProps {
  value: ISelectOption;
  disabled?: boolean;
  onChange: (s: ISelectOption) => void;
  allowedTeams?: string[];
}

export const TeamSelect = (props: IProps): React.ReactElement => {
  const { teams, loading } = useEntities();
  const { value, disabled } = props;

  /**
   * @description creates a memoized list of items grouped by team that updates when props update
   */
  const data = React.useMemo((): ISelectableEntity[] => {
    return teams
      .filter((team: ITeam): boolean => {
        /// filter the teams if only a subset should be displayed
        if (!props.allowedTeams) return true;
        return props.allowedTeams.includes(team.id);
      })
      .map(
        (a: ITeam): ISelectableEntity => ({
          label: a.name,
          value: a.id,
          entity: a,
        })
      );
  }, [teams?.length]);

  const onChange = (opt: ISelectOption): void => {
    props.onChange(opt);
  };

  return (
    <Select
      options={data}
      controlShouldRenderValue
      value={value}
      isDisabled={disabled}
      components={makeAnimated()}
      onChange={onChange}
      cache={false}
      id={'input-select'}
    />
  );
};
